import React from "react";
import PageHero from "../components/PageHero";
import Services from "../components/Services";
import EnergyEstimator from "../components/EnergyEstimator";
import FinalCTA from "../components/FinalCTA";

export default function ServicesPage() {
  return (
    <>
      <PageHero
        eyebrow="What We Power"
        title={["SOLAR SERVICES", "FOR EVERY", "KIND OF ROOF."]}
        subtitle="Residential, commercial and industrial systems — shared across both Selectra Solar locations."
      />
      <Services />
      <EnergyEstimator />
      <FinalCTA />
    </>
  );
}
